import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import {
  Box,
  Button,
  Typography,
  // ButtonGroup,
  Tabs,
  Tab,
} from "@mui/material";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { blue, red, yellow } from "@mui/material/colors";
import ModalAddMultiple from "./ModalAddMultiple";
// import ModalAddTemplateExcel from "./ModalAddTemplateExcel";
import ModalAddManyProblem from "./ModalAddManyProblem";
import ModalAddManyTxt from "./ModalAddManyTxt";

// Define the theme
const theme = createTheme({
  palette: {
    primary: { main: blue[500] },
    secondary: { main: yellow[500] },
    third: { main: red[800] },
    hover: { dark: blue[500] },
  },
});

// DrawerHeader styled component
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const ContentPageAddManyExam = () => {
  const steps = [
    {
      label: "ขั้นตอนที่ 1 อัพโหลดไฟล์ excel",
      content: (
        <>
          <p>ขั้นตอนที่ 1 อัพโหลดไฟล์ excel</p>
          <p>กรุณาใช้แบบฟอร์มของระบบ</p>
          <br />
          <ModalAddMultiple />
        </>
      ),
    },
    {
      label: "ขั้นตอนที่ 2 อัพโหลดไฟล์เสียง mp3",
      content: (
        <>
          <p>ขั้นตอนที่ 2 อัพโหลดไฟล์เสียง mp3</p>
          <ul>
            <li>ไฟล์เสียงโจทย์ .mp3</li>
            <li>ไฟล์เสียงคำถาม .mp3</li>
            <li>ไฟล์เสียงลำดับข้อ .mp3</li>
            <li>ไฟล์เสียงคำแนะนำ .mp3</li>
          </ul>
          <br />
          <ModalAddManyProblem />
        </>
      ),
    },
    {
      label: "ขั้นตอนที่ 3 อัพโหลดไฟล์ .txt",
      content: (
        <>
          <p>ขั้นตอนที่ 3 อัพโหลดไฟล์ .txt</p>
          <ul>
            <li>โจทย์ไฟล์ .txt</li>
          </ul>
          <br />
          <ModalAddManyTxt />
        </>
      ),
    },
  ];
  const [activeStep, setActiveStep] = useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveStep(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <Typography component="div">
        <Box sx={{ textAlign: "center", fontSize: 24, fontWeight: 500 }}>
          เพิ่มโจทย์ข้อสอบ
        </Box>
      </Typography>

      <DrawerHeader />

      {/* Navigation and Back Button */}
      <Link to="/PageExamArchive" style={{ textDecoration: "none" }}>
        <Button variant="outlined" startIcon={<ArrowBack />}>
          ย้อนกลับ
        </Button>
      </Link>

      {/* File upload navigation bar */}
      {/* <FileUploadNavBar /> */}

      {/* Tabs for Steps */}
      <Box sx={{ width: "100%", bgcolor: "background.paper", mt: 3 }}>
        <Tabs
          value={activeStep}
          onChange={handleTabChange}
          //variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="basic tabs example"
        >
          {steps.map((step, index) => (
            <Tab
              key={index}
              label={
                <Typography
                  variant="button"
                  gutterBottom
                  sx={{ display: "block" }}
                >
                  {step.label}
                </Typography>
              }
            />
          ))}
        </Tabs>
      </Box>

      {/* Content for Active Step */}
      <Box
        sx={{
          p: 3,
          border: "1px solid #ddd",
          borderRadius: "8px",
          backgroundColor: "white",
          mt: 3,
        }}
      >
        <Typography>{steps[activeStep].content}</Typography>
      </Box>

      {/* File Upload Buttons */}
      {/* <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
        <ModalAddMultiple />
        <ModalAddTemplateExcel />
        <ModalAddManyProblem />
        <ModalAddManyTxt />
      </Box> */}
    </ThemeProvider>
  );
};

export default ContentPageAddManyExam;
